import * as React from "react";
import { AppTranslations } from "../../../../components/Utils/translations/AppTranslations";
import { useProcessController } from "../../../Processes";
import { MotionProps } from "framer-motion";

declare var AppTranslations: AppTranslations;

interface AnimationContextType {
	variants: unknown;
	direction: number;
	props: MotionProps;
	updateDirection: (direction: 1 | -1) => void;
}

export const AnimationContext = React.createContext<AnimationContextType>(
	{} as any,
);

export const AnimationProvider: React.FC = ({ children }) => {
	const processController = useProcessController();
	const [lastPage, setLastPage] = React.useState(processController.position);
	const [direction, setDirection] = React.useState(1);

	const updateDirection = (direction: 1 | -1) => {
		setDirection(direction);
	};

	const variants = {
		enter: (direction: number) => {
			return {
				x: direction > 0 ? 1000 : -1000,
				transition: { duration: 1 },
			};
		},
		center: {
			x: 0,
		},
		exit: (direction: number) => {
			return {
				x: direction < 0 ? 10000 : -10000,
				transition: { duration: 1 },
				width: 0,
			};
		},
	};

	const props = {
		initial: "enter",
		animate: "center",
		exit: "exit",
		custom: direction,
		variants: variants,
		transition: { x: { type: "keyframes", stiffness: 300, damping: 30 } },
		style: { width: "100%", display: "flex" },
	};

	React.useEffect(() => {
		setLastPage(processController.position);
	}, [processController.position]);

	return (
		<AnimationContext.Provider
			value={{
				variants,
				direction,
				props,
				updateDirection,
			}}
		>
			{children}
		</AnimationContext.Provider>
	);
};
